/** Comms routes: staff conversations and the public read-only message page. */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appRoute } from '@/app/appRoute';
import { publicRoute } from '@/app/publicRoute';
import { str } from '@/lib/search';

export interface ConversationsSearch {
  /** Whose inbox: every driver conversation in scope, or my own (notifications, escalations). */
  box?: 'mine';
  unread?: boolean;
  status?: 'open' | 'closed';
  driver?: string;
  selected?: string;
}

export const conversationsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/messages',
  validateSearch: (s: Record<string, unknown>): ConversationsSearch => ({
    box: s.box === 'mine' ? 'mine' : undefined,
    unread: s.unread === true || s.unread === 'true' ? true : undefined,
    status: s.status === 'open' || s.status === 'closed' ? s.status : undefined,
    driver: str(s.driver),
    selected: str(s.selected),
  }),
  component: lazyRouteComponent(() => import('./pages/ConversationsPage')),
});

/** One conversation (links from actions, the assistant and search point here). */
export const conversationRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/messages/$conversationId',
  staticData: { permission: 'comms.message.read' },
  component: lazyRouteComponent(() => import('./pages/ConversationPage')),
});

/**
 * Public, outside the app shell and without a session (IA §2 Public): a read-only view of one
 * message by capability link. Listed in the module's `publicRoutes`.
 */
export const publicMessageRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: '/m/$token',
  component: lazyRouteComponent(() => import('./pages/PublicMessagePage')),
});
